import { render } from "./AccountRegistrationSuccess.vue?vue&type=template&id=07752fcb"
import script from "./AccountRegistrationSuccess.vue?vue&type=script&lang=js"
export * from "./AccountRegistrationSuccess.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__